import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["video", "toggle", "replay"]

  connect() {
    this.motion = window.matchMedia("(prefers-reduced-motion: reduce)")
    this.beforeCache = () => this.reset()
    this.motionChanged = () => { if (this.motion.matches) this.videoTarget.pause() }
    document.addEventListener("turbo:before-cache", this.beforeCache)
    this.motion.addEventListener("change", this.motionChanged)
    this.videoTarget.muted = true
    if (this.hasToggleTarget) this.toggleTarget.hidden = false
    if (this.hasReplayTarget) this.replayTarget.hidden = false
    this.update()
    this.observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        this.observer.disconnect()
        if (!this.motion.matches && !this.element.dataset.played) this.play()
      }
    }, { threshold: 0.2 })
    this.observer.observe(this.videoTarget)
  }

  async play() {
    this.element.dataset.played = "true"
    await this.videoTarget.play()
  }

  toggle() {
    if (this.videoTarget.paused) this.play()
    else this.videoTarget.pause()
  }

  replay() {
    this.videoTarget.currentTime = 0
    this.play()
  }

  update() {
    if (!this.videoTarget.paused) this.element.dataset.played = "true"
    if (this.hasToggleTarget) this.toggleTarget.textContent = this.videoTarget.paused ? "Play video" : "Pause video"
  }

  reset() {
    this.videoTarget.pause()
    this.videoTarget.currentTime = 0
    this.update()
  }

  disconnect() {
    this.observer.disconnect()
    document.removeEventListener("turbo:before-cache", this.beforeCache)
    this.motion.removeEventListener("change", this.motionChanged)
    this.reset()
  }
}
